import { Switch, withStyles } from "@material-ui/core";

const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 37,
    height: 20,
    padding: 0,
    margin: theme.spacing(1),
    boxShadow: "none"
  },
  switchBase: {
    padding: "2px",
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: '#28A382',
        opacity: 1,
        border: 'none',
      },
    },
    '&$focusVisible $thumb': {
      color: '#52d869',
      border: '6px solid ',
    },
  },
  thumb: {
    width: 16,
    height: 16,
  },
  track: {
    borderRadius: "50px",
    // border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default CustomSwitch;
